import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ApiService } from '../shared/services/api.service';

import { AnswerBatch, QuestionnaireAnswer, Questionnaire, QuestionnaireQuestion, QMenuOption, Bill, Customer } from "../shared/models";
import { faSpinner } from '../icons';
@Component({
    selector: 'app-customer-evaluations',
    templateUrl: './customer-evaluations.component.html',
    styleUrls: ['./customer-evaluations.component.scss'],
    standalone: false
})
export class CustomerEvaluationsComponent implements OnInit {
    faSpinner = faSpinner;
  bill: Bill = <Bill>{};
  code: string;

  questionnaire: Questionnaire;
  questions: QuestionnaireQuestion[] = [];

  answerBatch: AnswerBatch = <AnswerBatch>{};
  questionnaireAnswers: QuestionnaireAnswer[] = [];

  answersSent: boolean = false;

  constructor(private api: ApiService,
    private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.api = this.api.setAuth({}, false);
    this.api.disableApiPath();
    
    this.route.paramMap.subscribe(
      res => {
        let company_name = res["params"]["company_name"];
        let questionnaire_type = res["params"]["questionnaire_type"];

        if(company_name) {
          if(questionnaire_type) {
            switch(questionnaire_type) {
              case "padrao": {
                questionnaire_type = "default";
                break;
              }
              case "delivery": {
                questionnaire_type = "delivery";
                break;
              }
              case "presencial": {
                questionnaire_type = "on_site";
                break;
              }
              default: {
                questionnaire_type = "default";
              }
            }
          } else {
            questionnaire_type = "default";
          }

          this.loadQuestionnaire(company_name, questionnaire_type);
        } else {
          alert("Empresa não encontrada");
        }
      },
      err => {
        console.log(err);
      }
    );

    this.route.queryParams.subscribe(
      res => {
        if(res.code) {
          this.code = res.code;
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  loadQuestionnaire(company_name: string, type_s: 'default'|'on_site'|'delivery') {
    this.api.index('questionnaires', {
      company_name: company_name,
      type_s: type_s
    }, {
      collection: 'fetch'
    }).subscribe(
      res => {
        if(JSON.stringify(res.questionnaire) == "[]") {
          alert("Não há questionários para esta empresa");
        } else {
          this.initQuestionnaire(res.questionnaire);
        }
      }
    );
  }

  initQuestionnaire(questionnaire: Questionnaire) {
    this.questionnaire = questionnaire;

    Questionnaire.orderQuestions(this.questionnaire);

    for(let question of this.questionnaire.questionnaire_questions) {
      QuestionnaireQuestion.init(question, 0);
    }

    this.questions = this.questionnaire.questionnaire_questions;
  }

  fetchResults(json: {customer: Customer, answers: {
    id: number,
    title: string,
    answer: string
  }[]}) {

    let customer = <any>json.customer;
    if(!customer) {
      if(this.code) {
        customer = {code: this.code};
      }
    } else {
      customer.code = this.code;
    }
    
    let answers = json.answers;

    let cinfo = JSON.stringify(customer);

    this.api.create("answer_batches", {
      answer_batch: {
        company_id: this.questionnaire.company_id,
        //customer_id: this.bill.customer_id,
        //bill_id: this.bill.id,
        questionnaire_id: this.questionnaire.id,
        phone: customer.phone,
        email: customer.email,
        customer_info: cinfo
      }
    }).subscribe(
      res => {
        this.answerBatch = res.answer_batch;
        this.sendAnswers(answers);
      },
      err => {
        alert("Erro ao enviar respostas!");
        console.log(err);
      }
    );
  }

  sendAnswers(answers: {
                  id: number,
                  title: string,
                  answer: string
              }[], index: number = 0) {

    let answer = answers[index];
    this.api.create("questionnaire_answers", {
      questionnaire_answer: {
        title: answer.title,
        answer: answer.answer,
        answer_batch_id: this.answerBatch.id,
        questionnaire_question_id: answer.id
      }
    }).subscribe(
      res => {
        if(index == answers.length - 1) {
          alert("Respostas enviadas!");
          this.answersSent = true;
        } else {
          this.sendAnswers(answers, index + 1);
        }
      },
      err => {
        alert("Erro ao enviar resposta: " + answer[index].answer);
        console.log(err);
      }
    );
  }

  mockDelivery(): QuestionnaireQuestion[] {
    let questions = [{
      id: 1,
      type_s: 'yes-no',
      title: `Obrigado por estar avaliando nosso delivery!
O pedido chegou dentro do prazo previsto?`,
      children: [{
        selection: 'NÃO',
        question_id: 2,
        msgToPrepend: `Pedimos desculpas por isto.
Já estamos informando nosso setor responsável.`
      }, {
        selection: 'SIM',
        question_id: 2,
        msgToPrepend: "Ficamos felizes em saber disto!"
      }]
    },{
      id: 2,
      type_s: 'rate0-5',
      title: "Como você avaliaria nosso entregador?",
      children: [{
        selection: '5',
        question_id: 4,
        msgToPrepend: 'Que bom!!'
      }, {
        selection: ['3','4'],
        question_id: 3,
        msgToPrepend: "Alguma sugestão de como podemos melhorar?"
      }, {
        selection: ['1','2'],
        question_id: 3,
        msgToPrepend: `Sentimos muito por isto!
Por favor, nos conte o que aconteceu`
      }]
    }, {
      id: 3,
      type_s: 'text',
      title: '',
      children: [{question_id: 4}]
    }, {
      id: 4,
      type_s: 'multimenu',
      title: 'Como você avalia a refeição?',
      minSelectedItems: 3,
      maxSelectedItems: 3,
      selectOptions: <QMenuOption[]>[{
        label: 'Bem servida'
      }, {
        label: 'Bem temperada'
      }, {
        label: 'Chegou quentinha'
      }, {
        label: 'Pouca comida'
      }, {
        label: 'Pouco sabor'
      }, {
        label: 'Chegou morna/fria'
      }],
      children: [{question_id: 999}]
    }, {
      id: 999,
      title: 'Algo mais que deseja compartilhar conosco?',
      type_s: 'text'
    }];

    return <QuestionnaireQuestion[]>questions;
  }
}
